(function() {
    if (!Array.prototype.indexOf) {
        Array.prototype.indexOf = function(obj, start) {
            for (var i = (start || 0), j = this.length; i < j; i++) {
                if (this[i] === obj) { return i; }
            }
            return -1;
        }
    }

    // Avoid `console` errors in browsers that lack a console.
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

(function(window, $) {
    var helpers = {};

    helpers.encodeURL = function(url) {
        return encodeURIComponent(url).replace(/'/g,"%27").replace(/"/g,"%22");
    };

    helpers.decodeURL = function(url) {
        return decodeURIComponent(url.replace(/\+/g,  " "));
    };

    helpers.setCookie = function(c_name, c_val, expiretime) {
        if (Modernizr.localstorage) {
            return localStorage.setItem(c_name, c_val);
        } else {
            return $.cookie(c_name, c_val, {expires: expiretime, path: '/'});
        }
    };

    helpers.getCookie = function(c_name) {
        if (Modernizr.localstorage) {
            return localStorage.getItem(c_name);
        } else {
            return $.cookie(c_name);
        }
    };

    helpers.removeCookie = function(c_name) {
        if (Modernizr.localstorage) {
            return localStorage.removeItem(c_name);
        } else {
            return $.removeCookie(c_name);
        }
    };

    helpers.hasCookie = function(c_name) {
        if (Modernizr.localstorage) {
            return (localStorage.getItem(c_name) != null) ? true : false;
        } else {
            return ($.cookie(c_name)) ? true : false;
        }
    };

    helpers.getFullUrl = function(withHash, withSearch) {
        var url = window.location.protocol + "//" + window.location.host + window.location.pathname;
        if (withSearch) {url += window.location.search}
        if (withHash) {url += window.location.hash}
        return url;
    };

    window._n = function(number) {
        return Number(number);
    };

    window.addEvt = (function () {
        if (document.addEventListener) {
            return function (el, type, fn) {
                if (el && el.nodeName || el === window) {
                    el.addEventListener(type, fn, false);
                } else if (el && el.length) {
                    for (var i = 0; i < el.length; i++) {
                        window.addEvt(el[i], type, fn);
                    }
                }
            };
        } else {
            return function (el, type, fn) {
                if (el && el.nodeName || el === window) {
                    el.attachEvent('on' + type, function () { return fn.call(el, window.event); });
                } else if (el && el.length) {
                    for (var i = 0; i < el.length; i++) {
                        window.addEvt(el[i], type, fn);
                    }
                }
            };
        }
    })();

    window.splitHash = function(href) {
        var data = {};
        var hashIndex = href.indexOf('#');
        if (hashIndex == -1) {
            data.url  = href;
            data.hash = null;
        } else {
            data.url  = href.substring(0, hashIndex);
            data.hash = href.substring(hashIndex);
        }
        return data;
    };

    window.Helpers = helpers;
}(window, jQuery));

(function($) {
    $.fn.exists = function(){if(jQuery(this).length == 0){return false;}else{return true;}};
})(jQuery);
// END HELPERS
